import { TweenLite, Expo } from 'gsap'

$('.animate-title-wrap b').each(function (index) {
    TweenLite.to($(this), 1.2, {
        x: 0,
        ease: Expo.easeOut,
        delay: index / 5 + 1
    })
})
